import { GetDataTestIdFn } from '../../types';

const createDataTestIds =
  <K extends string = string>(
    prefix: string,
    overrideMap: Partial<Record<K, string>> = {}
  ): GetDataTestIdFn<K> =>
  (key: K) =>
    overrideMap[key] || `${prefix}-${key}`;

export default createDataTestIds;
